import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { EmailPreferenceLevelType } from './email-preference-level-type';
import { isEmpty } from 'lodash';

function convertLevelToString(level: EmailPreferenceLevelType): string {
    return EmailPreferenceLevelType[level];
}

function convertStringToLevel(level: keyof typeof EmailPreferenceLevelType): EmailPreferenceLevelType {
    return EmailPreferenceLevelType[level];
}

@Component({
    selector: 'email-preference-level-select',
    template: require('./email-preference-level-select.component.html'),
    styles: [require('./email-preference-level-select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailPreferenceLevelSelectComponent implements OnInit {
    @Input()
    public levels: EmailPreferenceLevelType[];

    @Output()
    public levelChange: EventEmitter<EmailPreferenceLevelType> = new EventEmitter<EmailPreferenceLevelType>();

    public stringLevels: string[];
    public selectedLevel: string;

    public ngOnInit() {
        if (isEmpty(this.levels)) {
            throw new Error('levels are not provided');
        }
        this.stringLevels = this.levels.map(l => convertLevelToString(l));
        this.selectedLevel = convertLevelToString(this.levels[0]);
    }

    public onLevelChange(levels: (keyof typeof EmailPreferenceLevelType)[]) {
        this.selectedLevel = levels[0];
        this.levelChange.emit(convertStringToLevel(levels[0]));
    }
}